<template>
    <div class="group-by-selector">
        <v-btn v-for="button in buttonsOptions" :key="button.value" text depressed class="gb-tab"
            :class="{ active: button.value === currentGroupBy }" @click="currentGroupBy = button.value">
            {{ button.name }}
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "GroupBySelector",
    props: {
        noMonthly: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: 'daily',
        },
        items: {
            type: Array,
            default: null,
        },
        height: {
            type: [String, Number],
            default: undefined
        },
        rounded: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            currentGroupBy: 'daily',
        }
    },
    computed: {
        buttons(vm = this) {
            if (vm.noMonthly) {
                return [
                    {name: vm.$t('statistics.weekly'), value: 'weekly'},
                    {name: vm.$t('statistics.daily'), value: 'daily'},
                ]
            }
            return [
                {name: vm.$t('statistics.monthly'), value: 'monthly'},
                {name: vm.$t('statistics.weekly'), value: 'weekly'},
                {name: vm.$t('statistics.daily'), value: 'daily'},
            ]
        },
        buttonsOptions(vm = this) {
            return vm.items ? vm.items : vm.buttons
        }
    },
    mounted() {
        const vm = this
        vm.setDefault()
    },
    methods: {
        setDefault() {
            const vm = this
            vm.currentGroupBy = vm.value
        },
    },
    watch: {
        currentGroupBy(val) {
            this.$emit('change', val)
        },
        value() {
            this.setDefault()
        }
    }
}
</script>

<style scoped>
.group-by-selector {
    display: inline-flex;
    gap: 2px;
}

.gb-tab.v-btn {
    height: 26px !important;
    min-width: 0;
    padding: 0 10px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    text-transform: none;
    letter-spacing: normal;
    color: var(--v-txtMuted-base);
    background: transparent !important;
    box-shadow: none !important;
}

.gb-tab.v-btn:hover {
    color: var(--v-txtSecondary-base);
}

.theme--dark .gb-tab.v-btn.active {
    background: var(--v-primary-base) !important;
    color: #0C0E12 !important;
}

.theme--light .gb-tab.v-btn.active {
    background: var(--v-accent-base) !important;
    color: #FFFFFF !important;
}
</style>